import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StackingCard from "../StackingCard/Card";
import { getAllStakingPools } from "../../store/stakingStore";
import styles from "./index.module.scss";

function StackingCardList() {
  const dispatch = useDispatch();
  const stakingContract = useSelector((state) => state.stakingSlice.contract);
  const allStakingPools = useSelector(
    (state) => state.stakingSlice.allStakingPools
  );

  useEffect(() => {
    dispatch(getAllStakingPools());
  }, [stakingContract, dispatch]);
  return (
    <div className={styles.container}>
      <div className={styles.layout}>
        {allStakingPools &&
          allStakingPools.map((stackingPool, key) => (
            <StackingCard stackingPool={stackingPool} key={key} />
          ))}
      </div>
    </div>
  );
}

export default StackingCardList;
